import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import ContactModal from '../components/contact-modal'
import Footer from '../components/footer'
import Mark from '../components/mark'
import FAQ from '../components/faq'
import './home.css'

const SocialMediaRecruitingKampagnen = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const [buttonSource, setButtonSource] = useState('')

  const openContactModal = (source = 'Unbekannt') => {
    setButtonSource(source)
    setIsContactModalOpen(true)
  }

  const closeContactModal = () => {
    setIsContactModalOpen(false)
  }

  return (
    <div className="home-container1">
      <Helmet>
        <title>Social Media Recruiting Kampagnen Berlin | Erfolgreiche Recruiting Kampagnen für Ihr Unternehmen</title>
        <meta name="description" content="Professionelle Social Media Recruiting Kampagnen in Berlin: Von der Konzeption bis zur Umsetzung. Erreichen Sie qualifizierte Kandidaten über LinkedIn, Facebook und Instagram." />
        <meta property="og:title" content="Social Media Recruiting Kampagnen Berlin | Erfolgreiche Recruiting Kampagnen" />
        <meta property="og:description" content="Ihre Experten für Social Media Recruiting Kampagnen in Berlin. Wir entwickeln und managen erfolgreiche Kampagnen für Ihre Mitarbeitergewinnung." />
      </Helmet>
      
      <Navbar rootClassName="navbarroot-class-name" onContactClick={openContactModal}></Navbar>

      <section className="home-section10">
        <div className="home-hero">
          <div className="home-content1">
            <main className="home-main1">
              <header className="home-header10" >
                <h1 className="home-heading10">
                  Social Media Recruiting Kampagnen: Gewinnen Sie die besten Talente über soziale Netzwerke
                </h1>
                <span className="home-caption1">
                  Als spezialisierte Social Recruiting Agentur in Berlin entwickeln wir erfolgreiche Social Media Recruiting Kampagnen, die qualifizierte Bewerber ansprechen und Ihr Employer Branding stärken. Von LinkedIn über Facebook bis Instagram – wir kennen die Erfolgsfaktoren jeder Plattform.
                </span>
              </header>
              <div className="home-buttons1">
                <div className="home-get-started1 button" onClick={() => openContactModal('Kampagne starten')} style={{ cursor: 'pointer' }}>
                  <span className="home-text10">Kampagne starten</span>
                </div>
              </div>
            </main>
          </div>
          <div className="home-image13">
            <img
              alt="Social Media Recruiting Kampagnen Berlin"
              src="/social-media-recruiting-agentur-kampagne.png"
              className="home-image14"
            />
          </div>
        </div>
      </section>

      <section className="home-section11" style={{ marginTop: '80px' }}>
        <h2 className="home-text12">
          Was macht erfolgreiche Social Media Recruiting Kampagnen aus?
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Wie Social Media Recruiting Kampagnen Ihre Mitarbeitergewinnung revolutionieren
              </h2>
              <p className="home-paragraph1">
                <span>
                  Social Media Recruiting Kampagnen sind weit mehr als einfache Stellenanzeigen auf Facebook oder LinkedIn. Eine erfolgreiche Kampagne ist ein strategisch geplantes, kreativ umgesetztes und datengetrieben optimiertes Projekt, das potenzielle Kandidaten auf ihrer gesamten Customer Journey begleitet – vom ersten Kontakt mit Ihrer Arbeitgebermarke bis zur finalen Bewerbung. Als Social Recruiting Agentur in Berlin haben wir hunderte solcher Kampagnen erfolgreich umgesetzt und wissen genau, worauf es ankommt.
                </span>
                <br></br>
                <br></br>
                <span>
                  Der Fachkräftemangel macht traditionelle Recruiting-Methoden zunehmend ineffektiv. Stellenanzeigen auf Jobbörsen erreichen oft nur aktiv suchende Kandidaten – und selbst diese scrollen meist schnell weiter, wenn die Anzeige nicht überzeugt. Social Media Recruiting Kampagnen bieten hier einen entscheidenden Vorteil: Sie erreichen auch passive Kandidaten, die nicht aktiv auf Job-Suche sind, aber offen für neue Chancen wären. Durch gezieltes Targeting können Sie Ihre Stellenanzeigen genau den Menschen ausspielen, die am besten zu Ihrer offenen Position passen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Eine professionelle Social Media Recruiting Kampagne beginnt mit einer gründlichen Analyse: Wer ist Ihre Zielgruppe? Wo bewegt sie sich online? Welche Inhalte sprechen sie an? Welche Pain Points haben potenzielle Bewerber, und wie können Sie diese in Ihrer Kommunikation adressieren? Basierend auf diesen Erkenntnissen entwickeln wir als Social Recruiting Agentur eine maßgeschneiderte Kampagnen-Strategie, die perfekt auf Ihre Bedürfnisse zugeschnitten ist.
                </span>
                <br></br>
                <br></br>
                <span>
                  Der Erfolg von Social Media Recruiting Kampagnen liegt in der Kombination verschiedener Elemente: Authentisches Employer Branding zeigt Ihre Unternehmenskultur und macht Sie als Arbeitgeber greifbar. Präzises Targeting stellt sicher, dass Ihre Botschaft die richtigen Menschen erreicht. Überzeugende Creatives und Texte wecken Interesse und motivieren zur Bewerbung. Und kontinuierliche Optimierung sorgt dafür, dass Ihre Kampagne im Laufe der Zeit immer bessere Ergebnisse liefert.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Kampagnen-Strategie entwickeln')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Kampagnen-Strategie entwickeln →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Social Recruiting Kampagne Strategie"
              src="/social-media-recruiting-agentur-erfolg.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Die Phasen einer erfolgreichen Social Media Recruiting Kampagne</h2>
          <span className="home-text26">
            Als erfahrene Social Recruiting Agentur in Berlin begleiten wir Sie durch alle Phasen Ihrer Recruiting Kampagne – von der Planung bis zur Erfolgsmessung.
          </span>
        </header>
        
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Kampagnen-Planung Social Recruiting"
              src="/social-media-recruiting-agentur-funktion.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Planung & Konzeption</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Strategische Kampagnen-Planung für maximalen Recruiting-Erfolg
                </h2>
                <p className="section-description">
                  Jede erfolgreiche Social Media Recruiting Kampagne beginnt mit einer gründlichen Planungsphase. Wir definieren gemeinsam mit Ihnen klare Ziele: Wie viele qualifizierte Bewerbungen möchten Sie generieren? Welche Positionen sollen besetzt werden? Welches Budget steht zur Verfügung? Diese Ziele sind die Grundlage für alle weiteren Entscheidungen.
                  
                  Die Zielgruppenanalyse ist der nächste entscheidende Schritt. Wir erstellen detaillierte Candidate Personas, die demografische Merkmale, berufliche Qualifikationen, Interessen und Online-Verhalten Ihrer Wunschkandidaten beschreiben. Diese Personas helfen uns, die richtigen Social Media Plattformen auszuwählen und das Targeting präzise zu konfigurieren. Für IT-Fachkräfte ist LinkedIn oft die erste Wahl, während Sie jüngere Talente besser über Instagram oder TikTok erreichen.
                  
                  In der Konzeptionsphase entwickeln wir die kreative Strategie Ihrer Kampagne. Welche Botschaft möchten Sie vermitteln? Welche Content-Formate setzen wir ein – Videos, Bilder, Carousel Ads? Wie integrieren wir Ihr Employer Branding? Als Social Recruiting Agentur mit langjähriger Erfahrung wissen wir, welche Ansätze funktionieren und können Ihnen bewährte Best Practices an die Hand geben, gleichzeitig aber auch innovative Ideen einbringen, die Sie von Wettbewerbern abheben.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('Kampagne planen')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">Kampagne planen lassen</span>
            </div>
          </div>
        </section>

        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Content-Produktion Recruiting"
              src="/social-media-recruiting-agentur-content.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Content-Produktion & Creative
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Recruiting Content, der auffällt und überzeugt
                  </h2>
                  <p className="section-description">
                    Die Content-Produktion ist das Herzstück jeder Social Media Recruiting Kampagne. Hier entscheidet sich, ob potenzielle Bewerber stehenbleiben und sich für Ihre Stellenanzeige interessieren – oder weiterscrollen. Als Social Recruiting Agentur produzieren wir Content, der nicht nur professionell aussieht, sondern vor allem authentisch ist und Ihre Arbeitgebermarke überzeugend kommuniziert.
                    
                    Video-Content performa auf Social Media besonders gut. Wir produzieren Employer-Branding-Videos, in denen Mitarbeiter über ihren Arbeitsalltag sprechen, Behind-the-Scenes-Clips, die einen Einblick in Ihr Unternehmen geben, oder animierte Erklärvideos, die Karrieremöglichkeiten aufzeigen. Wichtig ist dabei immer die Authentizität – hochglanzpolierte Werbevideos wirken oft weniger überzeugend als echte, ungeschönte Einblicke in Ihren Unternehmensalltag.
                    
                    Natürlich produzieren wir auch statische Creatives für Ihre Recruiting Ads: Eye-Catching Grafiken mit klaren Botschaften, Carousel Ads, die verschiedene Aspekte Ihrer Arbeitgebermarke präsentieren, oder dynamische Anzeigen, die automatisch personalisiert werden. Alle Creatives werden für die jeweilige Plattform optimiert – was auf LinkedIn funktioniert, muss auf Instagram anders aufbereitet werden.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Authentische Video-Produktion für Employer Branding"></Mark>
                  <Mark label="Plattform-optimierte Creatives und Anzeigen-Designs"></Mark>
                  <Mark label="A/B-Testing verschiedener Content-Varianten"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Content produzieren lassen')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Content produzieren lassen</span>
            </div>
          </div>
        </section>
      </section>

      <section className="home-section11">
        <h2 className="home-text12">
          Plattform-spezifische Social Media Recruiting Kampagnen: LinkedIn, Facebook, Instagram & mehr
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11" style={{ marginTop: '90px' }}>
                Wie Sie jede Social Media Plattform optimal für Ihre Recruiting Kampagne nutzen
              </h2>
              <p className="home-paragraph1">
                <span>
                  <strong>LinkedIn Recruiting Kampagnen: Die erste Wahl für Fach- und Führungskräfte</strong><br/>
                  LinkedIn ist die führende Plattform für professionelles Networking und eignet sich hervorragend für Social Media Recruiting Kampagnen im B2B-Bereich und für hochqualifizierte Positionen. Mit über 800 Millionen Nutzern weltweit und einem hohen Anteil an Entscheidern und Fachkräften ist LinkedIn ideal für anspruchsvolle Recruiting-Projekte. Als Social Recruiting Agentur nutzen wir die umfangreichen Targeting-Möglichkeiten von LinkedIn: Sie können nach Jobtiteln, Fähigkeiten, Branchen, Unternehmensgröße und vielen weiteren Kriterien filtern, um Ihre Stellenanzeigen präzise auszuspielen.
                </span>
                <br></br>
                <br></br>
                <span>
                  LinkedIn bietet verschiedene Werbeformate für Recruiting Kampagnen: Sponsored Content erscheint direkt im Feed der Nutzer und ermöglicht verschiedene Formate von Single Image Ads über Video Ads bis zu Carousel Ads. Sponsored InMail (jetzt Message Ads) ermöglicht die direkte Ansprache potenzieller Kandidaten via LinkedIn Messenger – besonders effektiv für Active Sourcing. Text Ads sind kostengünstige, performanceorientierte Anzeigen, die in der Sidebar erscheinen. Dynamic Ads werden automatisch personalisiert und zeigen das Profilbild des Nutzers, was die Aufmerksamkeit erhöht.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Facebook Recruiting Kampagnen: Reichweite und präzises Targeting</strong><br/>
                  Facebook bleibt trotz neuer Plattformen einer der wichtigsten Kanäle für Social Media Recruiting Kampagnen. Mit über 2,9 Milliarden aktiven Nutzern erreichen Sie hier eine enorm breite Zielgruppe. Besonders effektiv ist Facebook für lokales Recruiting, für gewerbliche Positionen und für die Ansprache etwas älterer Zielgruppen (30+). Die Targeting-Möglichkeiten von Facebook sind außergewöhnlich detailliert: demografische Merkmale, Interessen, Verhaltensweisen, Lebensereignisse und vieles mehr können kombiniert werden.
                </span>
                <br></br>
                <br></br>
                <span>
                  Als Social Recruiting Agentur setzen wir auf Facebook verschiedene Kampagnen-Formate ein: Image und Video Ads im Feed, Stories Ads für mobile-first Content, Carousel Ads zur Präsentation verschiedener Aspekte Ihrer Arbeitgebermarke, und Facebook Jobs, das spezielle Recruiting-Format der Plattform. Besonders wertvoll ist auch die Möglichkeit, Custom Audiences zu erstellen – Sie können beispielsweise Website-Besucher retargeten oder Lookalike Audiences erstellen, um Menschen zu erreichen, die Ihren bisherigen Bewerbern ähnlich sind.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Instagram Recruiting Kampagnen: Die junge Zielgruppe authentisch ansprechen</strong><br/>
                  Instagram ist die Plattform der Wahl, wenn Sie jüngere Talente (18-35 Jahre) ansprechen möchten. Mit seiner visuellen Ausrichtung eignet sich Instagram perfekt für authentisches Employer Branding. Als Social Recruiting Agentur in Berlin entwickeln wir Instagram-Kampagnen, die die Besonderheiten der Plattform optimal nutzen: Stories ermöglichen spontane, authentische Einblicke in Ihren Arbeitsalltag. Reels – Instagrams Antwort auf TikTok – sind perfekt für kreative, unterhaltsame Recruiting-Content. Feed Posts bleiben relevant für hochwertigere, kurierte Inhalte.
                </span>
                <br></br>
                <br></br>
                <span>
                  Instagram Recruiting Kampagnen leben von Authentizität. User Generated Content, Mitarbeiter-Takeovers und Behind-the-Scenes-Content funktionieren hier besonders gut. Die Plattform ist weniger formal als LinkedIn, was Spielraum für kreativere Ansätze bietet. Gleichzeitig sollten Sie bedenken, dass Instagram-Nutzer nicht primär auf Job-Suche sind – Ihre Recruiting Ads müssen also besonders überzeugend sein, um aus dem normalen Content herauszustechen.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Plattform-Strategie entwickeln')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Plattform-Strategie entwickeln →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Social Media Plattformen Recruiting"
              src="/social-media-recruiting-agentur-linkedin.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Targeting & Optimierung: Die Erfolgsfaktoren jeder Recruiting Kampagne</h2>
          <span className="home-text26">
            Präzises Targeting und kontinuierliche Optimierung sind der Schlüssel zu erfolgreichen Social Media Recruiting Kampagnen. Als Social Recruiting Agentur nutzen wir datengetriebene Methoden für maximale Performance.
          </span>
        </header>
        
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Targeting Recruiting Kampagnen"
              src="/social-media-recruiting-agentur-gezielt.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Präzises Targeting</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Erreichen Sie genau die Kandidaten, die Sie suchen
                </h2>
                <p className="section-description">
                  Das Targeting ist einer der größten Vorteile von Social Media Recruiting Kampagnen gegenüber traditionellen Stellenanzeigen. Statt breit zu streuen und zu hoffen, dass die richtigen Kandidaten Ihre Anzeige sehen, können Sie auf Social Media präzise definieren, wer Ihre Recruiting Ads sehen soll. Als Social Recruiting Agentur mit umfangreicher Erfahrung wissen wir genau, welche Targeting-Optionen für welche Zielgruppen am besten funktionieren.
                  
                  Auf LinkedIn können Sie nach Jobtiteln, Fähigkeiten, Branchen, Unternehmen, Bildungsabschlüssen und vielen weiteren berufsbezogenen Kriterien targeten. Besonders wertvoll ist die Möglichkeit, nach Mitgliedschaften in bestimmten LinkedIn-Gruppen oder nach Interaktionen mit bestimmten Content-Typen zu filtern. So erreichen Sie beispielsweise gezielt Software-Entwickler mit Python-Kenntnissen, die in Startups im Bereich FinTech arbeiten und in Berlin oder Umgebung leben.
                  
                  Facebook und Instagram bieten andere, aber ebenso mächtige Targeting-Optionen: demografische Merkmale, Interessen, Verhaltensweisen, Lebensereignisse und Custom Audiences. Sie können Menschen targeten, die kürzlich umgezogen sind (potenzielle Kandidaten für lokale Positionen), die sich für bestimmte Themen interessieren (relevant für spezialisierte Fachpositionen) oder die bestimmte Websites besucht haben (Retargeting von Website-Besuchern).
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('Targeting-Strategie entwickeln')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">Targeting-Strategie entwickeln</span>
            </div>
          </div>
        </section>

        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Kampagnen-Optimierung"
              src="/social-media-recruiting-agentur-ads.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Kontinuierliche Optimierung
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Datengetriebene Optimierung für bessere Recruiting-Ergebnisse
                  </h2>
                  <p className="section-description">
                    Eine Social Media Recruiting Kampagne ist nie "fertig" – kontinuierliche Optimierung ist entscheidend für den Erfolg. Als Social Recruiting Agentur monitoren wir Ihre Kampagnen täglich und nehmen regelmäßig Anpassungen vor, um die Performance zu verbessern. Dabei nutzen wir einen datengetriebenen Ansatz: Wir analysieren, welche Ads die besten Ergebnisse liefern, welche Zielgruppen am stärksten konvertieren und wo Optimierungspotenzial liegt.
                    
                    A/B-Testing ist ein zentraler Bestandteil unserer Optimierungsstrategie. Wir testen verschiedene Varianten von Headlines, Bildern, Videos, Call-to-Actions und Targeting-Einstellungen gegeneinander, um herauszufinden, was am besten funktioniert. Diese Tests laufen kontinuierlich, sodass wir Ihre Kampagne laufend verbessern können. Oft zeigen sich dabei überraschende Erkenntnisse – manchmal performen weniger offensichtliche Ansätze deutlich besser als erwartete Varianten.
                    
                    Budget-Optimierung ist ein weiterer wichtiger Aspekt. Wir verteilen Ihr Recruiting-Budget dynamisch auf die am besten performenden Anzeigen und Plattformen. Wenn LinkedIn für Ihre Zielgruppe deutlich bessere Ergebnisse liefert als Facebook, wird mehr Budget dorthin verschoben. Wenn Video Ads besser konvertieren als Image Ads, investieren wir mehr in Video-Content. Diese flexible Allokation stellt sicher, dass Sie das Maximum aus Ihrem Budget herausholen.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Tägliches Performance-Monitoring und Reporting"></Mark>
                  <Mark label="A/B-Testing für kontinuierliche Verbesserung"></Mark>
                  <Mark label="Dynamische Budget-Optimierung für maximalen ROI"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Optimierung beauftragen')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Optimierung beauftragen</span>
            </div>
          </div>
        </section>
      </section>

      <section className="home-section15">
        <header className="home-header13">
          <header className="home-left1">
            <span className="section-head">Unsere Kampagnen-Expertise</span>
            <h2 className="section-heading">
              <span>Warum Unternehmen aus Berlin und ganz Deutschland</span>
              <br></br>
              <span>auf unsere Social Media Recruiting Kampagnen vertrauen</span>
            </h2>
          </header>
          <div className="home-right1">
            <p className="home-paragraph4 section-description">
              Als spezialisierte Social Recruiting Agentur in Berlin haben wir hunderte erfolgreiche Social Media Recruiting Kampagnen umgesetzt. Von Startups bis zu Mittelständlern, von IT über Healthcare bis Einzelhandel – wir kennen die Erfolgsfaktoren in verschiedensten Branchen.
            </p>
          </div>
        </header>
      </section>

      <section className="home-section11">
        <h2 className="home-text12">
          Erfolgsmessung & ROI: Wie Sie den Erfolg Ihrer Social Media Recruiting Kampagne messen
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11" style={{ marginTop: '60px' }}>
                Die wichtigsten KPIs für Social Media Recruiting Kampagnen
              </h2>
              <p className="home-paragraph1">
                <span>
                  Die Erfolgsmessung ist ein kritischer Aspekt jeder Social Media Recruiting Kampagne. Nur wenn Sie wissen, welche Ergebnisse Ihre Kampagne liefert, können Sie fundierte Entscheidungen über Budget-Allokation und strategische Ausrichtung treffen. Als Social Recruiting Agentur legen wir großen Wert auf transparentes Reporting und klare KPIs. Wir messen nicht nur Vanity Metrics wie Impressions und Likes, sondern fokussieren uns auf die Kennzahlen, die wirklich zählen.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Anzahl qualifizierter Bewerbungen:</strong> Die wichtigste Kennzahl überhaupt. Wie viele Bewerbungen haben Sie durch die Kampagne erhalten, und wie viele davon sind qualifiziert und passen zur ausgeschriebenen Position? Eine Kampagne, die 100 Bewerbungen generiert, von denen nur 5 qualifiziert sind, ist deutlich weniger erfolgreich als eine Kampagne mit 30 Bewerbungen, von denen 20 qualifiziert sind.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Cost per Application (CPA):</strong> Was kostet Sie eine Bewerbung? Diese Kennzahl errechnet sich aus dem gesamten Kampagnen-Budget geteilt durch die Anzahl der Bewerbungen. Ein niedriger CPA bedeutet, dass Ihre Kampagne effizient ist. Wichtig ist dabei, zwischen allen Bewerbungen und qualifizierten Bewerbungen zu unterscheiden – der Cost per Qualified Application ist die relevantere Kennzahl.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Click-Through-Rate (CTR):</strong> Wie viele Menschen, die Ihre Anzeige sehen, klicken darauf? Eine hohe CTR zeigt, dass Ihre Creatives und Botschaften relevant und ansprechend sind. Eine niedrige CTR kann darauf hindeuten, dass Ihr Targeting nicht präzise genug ist oder Ihre Anzeigen-Gestaltung optimiert werden sollte.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Conversion Rate:</strong> Wie viele Klicks auf Ihre Stellenanzeige führen zu Bewerbungen? Eine niedrige Conversion Rate kann verschiedene Ursachen haben: unpräzises Targeting (die Klicks kommen von nicht-qualifizierten Personen), Probleme mit der Landing Page oder dem Bewerbungsprozess, oder eine Diskrepanz zwischen der Anzeige und der tatsächlichen Stellenbeschreibung.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Time to Hire:</strong> Wie lange dauert es von der Schaltung Ihrer Kampagne bis zur erfolgreichen Besetzung der Position? Social Media Recruiting beschleunigt diesen Prozess oft deutlich im Vergleich zu traditionellen Methoden, da Sie schneller eine größere Anzahl qualifizierter Kandidaten erreichen.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Return on Investment (ROI):</strong> Letztendlich geht es darum, ob sich Ihre Investition in Social Media Recruiting lohnt. Der ROI berücksichtigt nicht nur die direkten Kampagnen-Kosten, sondern auch eingesparte Zeit, Kosten für alternative Recruiting-Kanäle und die Qualität der eingestellten Kandidaten. Als Social Recruiting Agentur helfen wir Ihnen, diese Gesamtrechnung aufzustellen und den wahren Wert Ihrer Social Media Recruiting Aktivitäten zu verstehen.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Reporting-Setup besprechen')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Reporting-Setup besprechen →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="KPIs Recruiting Kampagnen"
              src="/social-media-recruiting-agentur-wichtig.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section19">
        <div className="home-cube1">
          <div className="home-top1 side"></div>
          <div className="home-front1 side"></div>
          <div className="home-left2 side"></div>
        </div>
        <main className="home-banner">
          <div className="home-header15">
            <h2 className="section-heading">
              Starten Sie jetzt Ihre erfolgreiche Social Media Recruiting Kampagne
            </h2>
            <p className="home-description1 section-description">
              Lassen Sie uns gemeinsam eine Kampagne entwickeln, die qualifizierte Kandidaten anzieht und Ihre offenen Stellen besetzt!
            </p>
          </div>
          <div className="home-buttons2">
            <div className="home-get-started5 button" onClick={() => openContactModal('Kampagne beauftragen')} style={{ cursor: 'pointer' }}>
              <span className="home-text32">Kampagne jetzt beauftragen</span>
            </div>
          </div>
        </main>
      </section>

      <section className="home-section26">
        <header className="home-header22">
          <span className="section-head">FAQ</span>
          <h2 className="home-heading26 section-heading">
            Häufig gestellte Fragen zu Social Media Recruiting Kampagnen
          </h2>
        </header>
        <main className="home-accordion">
          <FAQ rootClassName="fa-qroot-class-name"></FAQ>
        </main>
      </section>

      <section className="home-section28">
        <main className="home-content6">
          <header className="home-header23">
            <h2 className="home-heading27 section-heading">
              Bereit für Ihre erfolgreiche Recruiting Kampagne? Kontaktieren Sie uns!
            </h2>
            <div className="home-buttons3">
              <div className="home-ios button" onClick={() => openContactModal('Kampagne starten')} style={{ cursor: 'pointer' }}>
                <span className="home-text50">Jetzt Kampagne starten</span>
              </div>
            </div>
          </header>
          <img
            alt="Social Media Recruiting Kampagnen Berlin"
            src="/social-media-recruiting-agentur-bereit.png"
            className="home-image25"
          />
        </main>
      </section>

      <Footer activePage="social-media-recruiting-kampagnen" />

      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} buttonSource={buttonSource} />
    </div>
  )
}

export default SocialMediaRecruitingKampagnen
